import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import GameEvent from "../../../core/application/GameEvent";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import HubEvent from "../../hub/event/HubEvent";
import KeyDecisionEvent from "../event/KeyDecisionEvent";
import KeyDecisionInteractionEvent from "../event/KeyDecisionInteractionEvent";

export default class KeyDecisionAvailableCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        super(dispatcher);

        this._handleKeyDecisionUnselectedBound = this._handleKeyDecisionUnselected.bind(this);
    }

    destroy() {
        this._dispatcher.removeEventListener(HubEvent.UNSELECT_KEY_DECISION_LIST_ITEM, this._handleKeyDecisionUnselectedBound);        
    }

    execute(evt) {
        this.dispatch(GameEvent.PAUSE_GAME);

        /** @type {KeyDecisionEvent} */
        const data = evt.params.data;
        const keyDecision = data.keyDecision;
        const delay = data.delay || 0;

        this._dispatcher.addEventListener(HubEvent.UNSELECT_KEY_DECISION_LIST_ITEM, this._handleKeyDecisionUnselectedBound);

        const transitionInDuration = 450;
        this._screenSkin = this.openPopup(SkinKeyRegistry.KEY_DECISION_AVAILABLE_SCREEN_SKIN, null, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(delay, transitionInDuration, createjs.Ease.sineInOut),
            priority: 2,
            needsOverlay: false,
        }, {
            keyDecision,
            transitionInDuration,
        });
    }

    _handleKeyDecisionUnselected() {
        this.closePopup(this._screenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });
        this._screenSkin = null;
        this.dispatch(GameEvent.RESUME_GAME);
        this.destroy();
    }
}